// extracted by mini-css-extract-plugin
module.exports = {"only-mobile":"Toast_only-mobile__KYF5q","only-desktop":"Toast_only-desktop__UWspl","root":"Toast_root__18K5j"};